<template>
  <vxe-grid
    ref="xTableStreet"
    class="table-block"
    border
    :highlight-hover-row="true"
    resizable
    :show-overflow="true"
    height="auto"
    max-height="500"
    align="center"
    size="mini"
    :checkbox-config="{ highlight: true }"
    :radio-config="{ highlight: true }"
    :empty-render="{name: 'NotData'}"
    :toolbar-config="{ custom: false }"
    :edit-config="{ trigger: 'manual', mode: 'row' }"
    :columns="columns"
    :data="tableData"
    @cell-dblclick="cellClick"
  />
</template>

<script>
import { getArea } from '@/api/sap/common-sap'

export default {
  props: {
    city: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      columns: [
        { type: 'checkbox', title: '', field: '', width: 50 },
        { field: 'STRT_CODE', title: '区/县编码', width: 120 },
        { field: 'MC_STREET', title: '区/县描述' }
      ],
      tableData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const { DATA } = await getArea(this.city, 'street')
      this.tableData = DATA
    },
    cellClick({ row, rowIndex, column }) {
      this.$refs.xTableStreet.setCheckboxRow(row, true)
    },
    submitForm() {
      return new Promise(r => {
        r(this.$refs.xTableStreet.getCheckboxRecords())
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/contract-manage/components/Street.vue